<template>
  <v-app>
    <Snackbar />
    <template>
      <div class="text-center">
        <v-overlay
          color='#399342'
          opacity="1"
          :value="overlay">
           <img
              width='120px'
              :src='require("@/assets/dna.gif")'
            />
          <div class="title font-weight-regular white--text mt-8">Please wait while we gather your data for you</div>
        </v-overlay>
      </div>
    </template>
    <v-navigation-drawer
      clipped
      style="position:fixed"
      v-model="drawer"
      height='100%'
      v-if='isAuthorized'
      dark
      color='primary'
      app>
      <v-divider></v-divider>
      <v-list
        nav
        dense
        flat>
        <template v-for="(item, keys) in items">
          <v-list-item
            v-if="surveyCheck(item)"
            v-bind:key='keys'
            link
            color='#9aff94'
            :to='item.route'>
            <v-list-item-icon>
                <v-icon> {{ item.icon }} </v-icon>
            </v-list-item-icon>
            <v-badge
              :dot="true"
              color="red"
              :value="item.badge">
              <template v-slot:badge><small>{{item.badge ? 'new' : false}}</small></template>
              <v-list-item-title>
                {{item.text}}
              </v-list-item-title>
            </v-badge>
          </v-list-item>
        </template>
      </v-list>
    </v-navigation-drawer>
        <v-app-bar
      v-if='!isPublic'
      app
      clipped-left>
        <v-app-bar-nav-icon v-if='isAuthorized' @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      <v-toolbar-title>
        <div>
          <v-img
            style="float: left;"
            src="./assets/staticAsset/logoSM.png"

            />
        </div>
      </v-toolbar-title>

      <v-spacer></v-spacer>

      <!-- <messageModal /> -->

      <span
				class='pl-5'
				v-if="isAuthorized && !($vuetify.breakpoint.name === 'xs' || $vuetify.breakpoint.name === 's')">
				Welcome, {{user.info.name}}
			</span>
      <div style="width:50px"></div>
      <v-btn
        text
        v-if='isAuthorized'
        @click='logout'>
        <v-icon>exit_to_app</v-icon>
        <div>
          Sign out
        </div>
      </v-btn>
      <div style="width:30px"></div>
    </v-app-bar>
    <v-content>
      <router-view/>
    </v-content>
  </v-app>
</template>

<script>
  import messageModal from './components/home/messagesModal';
  import Snackbar from './components/Snackbar';
  import { mapFields } from 'vuex-map-fields';
  import { getMessage } from '@/helper/firestore'
  import router from "./router"
  export default {
    name: 'App',
    components: {
      messageModal,
      Snackbar
    },
    mounted () {
      this.$root.$on('inactive', () => {
        this.inactivityTime()
      })
    },
    data () {
      return {
        drawer: null,
        items: [
          { icon: "home", text: "Home", route: "/home", badge: false},
          { icon: "face", text: "Intake", route: "/questionnaire", badge: false},
          { icon: "mdi-heart", text: "Health History Summary", route: "/healthhistory", badge: false},
          { icon: "mdi-account-group", text: "Family History Summary", route: "/familyHistory", badge: false},
          { icon: "mdi-book", text: "Report", route: "/report", badge: false},
          { icon: "mail", text: "Message Center", route: "/messaging", badge: false},
          { icon: "info", text: "Resource", route: "/resources", badge: false},
          { icon: "cloud_upload", text: "Upload", route: "/upload", badge: false},
          { icon: "person", text: "My Account", route: "/account", badge: false},
        ],
        surveyBlockedRoutes: [
          "/healthhistory",
          "/familyHistory"
        ]
      }
    },
    methods: {
      ispublic () {
        this.isPublic = router.currentRoute.path.includes("/public") ||  this.$router.currentRoute.path.includes("login")
      },
      inactivityTime () {
        var time;
        window.onload = resetTimer;
        // DOM Events
        document.onmousemove = resetTimer;
        document.onkeypress = resetTimer;

        function logout () {
           if(!router.currentRoute.path.includes("/public")){
          alert("Session timed out");
          location.href = '/';
           }
        }
        function resetTimer() {
         
          clearTimeout(time);
          time = setTimeout(logout, 900000);

          // 1000 milliseconds = 1 second
        }
      },
      surveyCheck(item) {
        return !this.surveyBlockedRoutes.includes(item.route) || this.user.complete;
      },
      logout() {
        window.location.reload();
      },
      routeTo(item) {
        router.push(item.route);
      },
    },
		watch:{
	    $route(to, from){
				getMessage((response) => {
	        this.messages = response.data;
					let index = this.items.findIndex(item => {
						return item.route === "/messaging"
					});
					var prevVal = this.items[index].badge;
					for (var i = 0; i < this.messages.length; i++) {
						var message = this.messages[i];
						var lastWasRead = !message.messageThread[message.messageThread.length - 1].read;
						var lastToUser = message.messageThread[message.messageThread.length - 1].message_to.email === this.user.email;
						if (lastWasRead && lastToUser) {
							this.items[index].badge = true;
							return;
						}
					}
					this.items[index].badge = false;
	      })
	    }
		},
    computed: {
      ...mapFields([
        'user',
        'overlay',
        'isPublic',
        'messages',
        'isAuthorized',
        'snackBarType',
        'snackBarshow',
        'messagesCount',
        'snackBarmessage',
      ]),
    },
  }
</script>
<style>
html .theme--light.v-card > .v-card__text {
  color: rgba(0,0,0,1);
}
</style>
